import React from "react";
import { useTranslation } from "react-i18next";

const PositionTypeLegend = React.memo(() => {
    const { t } = useTranslation();

    const items = [
        { icon: '🆕', color: '#2563eb', bg: '#eff6ff', label: t('invoice.position-type.new'), desc: t('invoice.position-type.new-description') },
        { icon: '📋', color: '#0891b2', bg: '#ecfeff', label: t('invoice.position-type.carried-forward'), desc: t('invoice.position-type.carried-forward-description') },
        { icon: '✏️', color: '#d97706', bg: '#fffbeb', label: t('invoice.position-type.modified-carried-forward'), desc: t('invoice.position-type.modified-carried-forward-description') },
    ];

    return (
        <div className="position-type-legend">
            {items.map((item, i) => (
                <span
                    key={i}
                    className="legend-pill"
                    style={{ '--pill-color': item.color, '--pill-bg': item.bg }}
                    title={item.desc}
                >
                    <span className="legend-icon">{item.icon}</span>
                    <span className="legend-label">{item.label}</span>
                </span>
            ))}
        </div>
    );
});

export default PositionTypeLegend;
